<template>
  <div class="main-frame">
    <div class="info-frame">
      <backHeader :ACodeStr="ACodeStr"> </backHeader>

      <!-- 占位高度 -->
      <van-divider class="top-divider" :style="{ borderColor: '#FFF' }" />
      <!-- 状态图片 -->
      <img class="title-img" src="../assets/image/img_fake.png" />
      <!-- 提示信息 -->
      <P class="info-msg">{{ $t("message.a_black_text") }}</P>
      <!-- 举报按钮 -->
      <van-button
        class="activate-btn"
        type="info"
        color="#30b3f0"
        @click="handleClick()"
        >{{ $t("message.A_fake_counterfeits") }}</van-button
      >
      <!-- APP下载 -->
      <van-button
        icon="wap-home-o"
        type="info"
        color="#30b3f0"
        class="download-btn"
        @click="downloadApp"
        >{{ $t("message.home_button_app") }}</van-button
      >
    </div>
    <div class="bottom-view">
      <!-- 装饰线条 -->
      <img class="img-margin" src="../assets/image/footer.png" />
      <!-- 版权说明 -->
      <foot></foot>
    </div>
  </div>
</template>

<script>
import foot from "@/components/Foot.vue";
import backHeader from "@/components/BackHeader.vue";
export default {
  components: {
    foot,
    backHeader,
  },
  name: "ABlackList",
  data() {
    return {
      text: "",
      ACodeStr: "",
    };
  },
  created() {
    if (this.$route.params.text != undefined) {
      this.text = this.$route.params.text;
      this.ACodeStr = this.$route.params.code;
    } else {
      // 返回主页
      this.$notify(this.$t("message.home_model_not_scanner_code_a"));
      this.$router.push({ name: "bind-home" });
    }
  },
  methods: {
    downloadApp() {
      this.$router.push({ name: "home" });
    },
    handleClick() {
      // 举报商家
      this.$router.push({ name: "inform", params: { data: this.text } });
    },
  },
};
</script>

<style scoped>
.main-frame {
  /*width: 100%;*/
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: white;
  text-align: center;
}

.info-frame {
  flex: 1;
}

.top-divider {
  background-color: white;
  margin: 0;
  height: 55px;
}

.title-img {
  width: 90px;
  height: 90px;
  margin-top: 60px;
}

.info-msg {
  margin-left: 30px;
  margin-top: 30px;
  font-size: 14pt;
  font-weight: initial;
  width: calc(100% - 60px);
}

.activate-btn {
  margin-top: 40px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.download-btn {
  margin-top: 16px;
  font-size: 14pt;
  width: calc(100% - 32px);
  border-radius: 8px;
}

.img-margin {
  width: 100%;
  height: 22px;
}

.bottom-view {
  min-height: 50px;
  margin-top: 20px;
  background-color: white;
}
</style>
